import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange, onReset }) => {
  const industries = ['all', 'Technology', 'Retail', 'Healthcare', 'Energy', 'Finance', 'Manufacturing'];
  const esgFocusAreas = ['all', 'Environmental', 'Social', 'Governance'];
  const companySizes = ['all', 'Small', 'Medium', 'Large'];
  const locations = ['all', 'California, USA', 'New York, USA', 'Massachusetts, USA', 'Texas, USA', 'London, UK', 'Oregon, USA'];

  return (
    <div className="bg-card border border-border rounded-xl p-6 sticky top-24">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground flex items-center">
          <Icon name="SlidersHorizontal" size={20} className="mr-2" />
          Filters
        </h3>
        <button
          onClick={onReset}
          className="text-sm text-primary hover:text-primary/80 transition-colors"
        >
          Reset
        </button>
      </div>
      <div className="space-y-6">
        {/* Industry Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Industry
          </label>
          <select
            value={filters?.industry}
            onChange={(e) => onFilterChange('industry', e?.target?.value)}
            className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            {industries?.map(industry => (
              <option key={industry} value={industry}>
                {industry === 'all' ? 'All Industries' : industry}
              </option>
            ))}
          </select>
        </div>

        {/* ESG Focus Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            ESG Focus Area
          </label>
          <select
            value={filters?.esgFocus}
            onChange={(e) => onFilterChange('esgFocus', e?.target?.value)}
            className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            {esgFocusAreas?.map(focus => (
              <option key={focus} value={focus}>
                {focus === 'all' ? 'All Focus Areas' : focus}
              </option>
            ))}
          </select>
        </div>

        {/* Company Size Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Company Size
          </label>
          <select
            value={filters?.companySize}
            onChange={(e) => onFilterChange('companySize', e?.target?.value)}
            className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            {companySizes?.map(size => (
              <option key={size} value={size}>
                {size === 'all' ? 'All Sizes' : size}
              </option>
            ))}
          </select>
        </div>

        {/* Location Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Location
          </label>
          <select
            value={filters?.location}
            onChange={(e) => onFilterChange('location', e?.target?.value)}
            className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            {locations?.map(location => (
              <option key={location} value={location}>
                {location === 'all' ? 'All Locations' : location}
              </option>
            ))}
          </select>
        </div>

        {/* ESG Score Range */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Minimum ESG Score: {filters?.minRating}
          </label>
          <input
            type="range"
            min="0"
            max="100"
            step="5"
            value={filters?.minRating}
            onChange={(e) => onFilterChange('minRating', parseInt(e?.target?.value))}
            className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer accent-primary"
          />
          <div className="flex justify-between text-xs text-muted-foreground mt-1">
            <span>0</span>
            <span>50</span>
            <span>100</span>
          </div>
        </div>
      </div>
      {/* Quick Stats */}
      <div className="mt-6 pt-6 border-t border-border">
        <h4 className="text-sm font-semibold text-foreground mb-3">Quick Stats</h4>
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Total Businesses</span>
            <span className="font-medium text-foreground">6</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Avg ESG Score</span>
            <span className="font-medium text-foreground">89.2</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Total Engagement</span>
            <span className="font-medium text-foreground">8.16K</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;